<template>
  <div class="detail_main">
    <el-row :gutter="32">
      <el-col :md="24" :lg="18">
        <div v-loading="loading" class="detail_content">
          <div class="detail_top">
            <h3>{{ newsDetail.title }}</h3>
            <div>
              <span class="category">{{ newsDetail.ctitle }}</span>
              <span>{{ newsDetail.create_time }}</span>
            </div>
          </div>
          <div v-if="newsDetail.video" class="detail_video">
            <video :src="newsDetail.video" width="100%" controls="controls"></video>
          </div>
          <div class="detail_contents" v-html="newsDetail.content"></div>
        </div>
      </el-col>
      <el-col :md="24" :lg="6">
        <div class="hot_news">
          <div class="hot_news_top">
            <span><i class="el-icon-reading"></i> 相关阅读</span>
          </div>
          <div v-for="(item,index) in newsList" :key="index" class="hot_news_list">
            <div class="hot_news_list_title">
              <router-link :to="'/news/detail?types='+types+'&id='+item.id">{{ item.title }}</router-link>
            </div>
            <div class="hot_news_list_description">{{ item.description }}</div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
// import 'element-ui/lib/theme-chalk/display.css'
import api from '@/api/article'
export default {
  name: 'Detail',
  data() {
    return {
      loading: true,
      newsDetail: {
        id: null,
        title: '',
        create_time: '',
        cover_img: '',
        content: '',
        ctitle: '',
        video: ''
      },
      newsList: [],
      types: null
    }
  },
  created() {
    if (this.$route.query.id) {
      this.newsDetail.id = this.$route.query.id
    }
    if (this.$route.query.types) {
      this.types = this.$route.query.types
    }
    this.getNewsDetail()
  },
  methods: {
    // 获取新闻详情
    getNewsDetail() {
      api.getNewsDetail({ types: this.types, id: this.newsDetail.id }).then(res => {
        this.loading = false
        this.newsDetail = res.data
        this.newsList = res.news_list
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.detail_main{
  padding: 32px;
  background-color:#fbfcfe;

  .detail_content{
    width: 70%;
    margin: 0 auto;
    min-height: 800px;
    border-radius: 5px;
    box-shadow: 0 0 0 0 rgba(0,0,0,0.1);
    margin-bottom: 16px;

    .detail_top{
      height: 100px;
      padding: 10px 0px;
      text-align: center;
      border-bottom: 1px solid #E4E7ED;
      h3{
        font-size: 26px;
        color: #909399;
        font-weight: 600;
        line-height: 40px;
        margin-bottom: 10px;
      }
      div span{
        color: #C0C4CC;
        font-size: 16px;
      }
      .category{
        color: #5BA5F2;
        margin-right: 15px;
      }
    }
    .detail_video{
      padding: 20px 0px;
    }
    .detail_contents{
      font-size: 18px;
      color: #606266;
      line-height: 1.2rem;
      padding: 20px;
      & >>> img {
        max-width: 100%;
      }
    }
  }
  .hot_news{
    min-height: 300px;
    border-radius: 5px;
    box-shadow: 0 2px 5px 0 rgba(0,0,0,0.1);
    margin-bottom: 16px;
    .hot_news_top{
      padding: 20px;
      border-bottom: 1px solid #E4E7ED;
      span{
        font-size: 26px;
        line-height: 28px;
        color: #909399;
        i{
          font-size: 22px;
        }
      }
    }
    .hot_news_list{
      padding: 10px 20px;
      font-size: 14px;
      color: #606266;
      line-height: 24px;
      box-shadow: 0 1px 0px 0 rgba(0,0,0,0.1);
      .hot_news_list_title{
        font-size: 16px;
        font-weight: bold;
        color: #5BA5F2;
        line-height: 34px;
        white-space: nowrap;
        text-overflow:ellipsis;
        -o-text-overflow:ellipsis;
        overflow: hidden;
      }
      .hot_news_list_description{
        height: 50px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
    }
  }
}
</style>
